export const profile = {
  path: "/profile",
  name: "profile",
  hidden: false,
  component: () => import("@/components/personal_data/index"),
  meta: {
    title: "Profil",
    icon: "fa-user",
    roles: ["pasien", "dokter"]
  },
  children: [
    {
      path: "personal_data",
      name: "PersonalData",
      hidden: true,
      meta: {
        title: "Data Diri",
        icon: "fa-area-chart",
        roles: ["pasien"]
      },
      component: () =>
        import("@/components/personal_data/components/personalData")
    },
    {
      path: "edit_profile",
      name: "editProfile",
      hidden: false,
      meta: {
        title: "Edit Profile",
        icon: "fa-area-chart",
        roles: ["pasien"]
      },
      component: () =>
        import("@/components/personal_data/components/editProfile")
    },
    {
      path: "edit_password",
      name: "editPassword",
      hidden: true,
      meta: {
        title: "Ubah Kata Sandi",
        icon: "fa-area-chart",
        roles: ["pasien"]
      },
      component: () =>
        import("@/components/personal_data/components/editPassword")
    }
  ]
};
export default profile;



// WEBPACK FOOTER //
// ./src/router/modules/profile.js